import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=ba91bf4c&scoped=true&"
import script from "./anchor.vue?vue&type=script&lang=js&"
export * from "./anchor.vue?vue&type=script&lang=js&"
import style0 from "./anchor.vue?vue&type=style&index=0&id=ba91bf4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba91bf4c",
  null
  
)

export default component.exports